export const en = {
  "Add module": "Add module",
  "Are you sure?": "Are you sure?",
  "auth": {
    "email": "Email",
    "enterEmail": "Enter your email",
    "enterName": "Enter your name",
    "enterPassword": "Enter your password",
    "enterSurname": "Enter your surname",
    "forgotPassword": "Forgot password?",
    "name": "Name",
    "password": "Password",
    "signIn": "Sign In",
    "signUp": "Sign Up",
    "surname": "Surname"
  },
  "bots": {
    "bot": "Bot",
    "bots": "Bots",
    "botsTable": "Bots table",
    "createBot": "Create bot",
    "deleteBot": "Delete bot",
    "editBot": "Edit bot",
    "table": {
      "createdAt": "Created at",
      "id": "Id",
      "identifier": "Identifier",
      "name": "Name",
      "type": "Type",
      "updatedAt": "Updated at",
      "username": "Username",
      "status": "Status"
    },
    "viewBot": "View bot"
  },
  "buttons": {
    "addNewMessage": "Add new message",
    "apply": "Apply",
    "cancel": "Cancel",
    "create": "Create",
    "delete": "Delete",
    "deleteSelected": "Delete selected",
    "edit": "Edit",
    "next": "Next",
    "search": "Search",
    "select": "Select",
    "skipAllDelay": "Skip all delay",
    "update": "Update",
    "registration": "Registration",
    "regenerateDialog": "Regenerate dialog",
    "restore": "Restore"
  },
  "channels": {
    "addNewButton": "Add new button",
    "botAnswer": "Bot Answer",
    "botAnswerIsActive": "Bot answer is active",
    "botAnswerIsNotActive": "Bot answer is not active",
    "buttonText": "Button text",
    "buttonUrl": "Button url",
    "channel": "Channel",
    "channels": "Channels",
    "channelsTable": "Channels table",
    "createChannel": "Create channel",
    "deleteBotAnswer": "Delete bot answer",
    "deleteChannel": "Delete channel",
    "deletePush": "Delete push",
    "editBotAnswer": "Edit bot answer",
    "editChannel": "Edit channel",
    "enterAfterTime": "Enter After Time",
    "enterMessage": "Enter Message",
    "enterText": "Enter Text",
    "enterUrl": "Enter Url",
    "push": "Push",
    "selectButtonType": "Select Button Type",
    "selectChannel": "Select channel",
    "selectTemplateId": "Select Template ID",
    "selectType": "Select Type",
    "table": {
      "afterTime": "After time",
      "createdAt": "Created at",
      "id": "Id",
      "identifier": "Identifier",
      "isActive": "Is Active",
      "message": "Message",
      "messageAt": "Message at",
      "name": "Name",
      "sourceId": "Source ID",
      "template": "Push",
      "type": "Type",
      "updatedAt": "Updated at"
    },
    "updatePush": "Update push",
    "viewChannel": "View channel",
    "noMessage": "No message"
  },
  "dtos": {
    "link_one": "Link",
    "link_other": "Links"
  },
  "fields": {
    "channel_one": "Channel",
    "channel_other": "Channels"
  },
  "footer": {
    "allRightsReserved": "All rights reserved"
  },
  "forms": {
    "apiHash": "API Hash",
    "apiId": "API ID",
    "botId": "Bot Id",
    "buyer": "Buyer",
    "channelId": "Channel Id",
    "client": "Client",
    "code": "Code",
    "email": "Email",
    "enterApiHash": "Enter API Hash",
    "enterApiId": "Enter API ID",
    "enterBuyer": "Enter Buyer",
    "enterCode": "Enter code",
    "enterFbPixel": "Enter fbPixel",
    "enterFbToken": "Enter fbToken",
    "enterName": "Enter Name",
    "enterPassword": "Enter Password",
    "enterPhoneNumber": "Enter phone number",
    "enterSource": "Enter Source",
    "enterUrl": "Enter URL",
    "enterUsername": "Enter Username",
    "fbPixel": "fbPixel",
    "fbToken": "fbToken",
    "name": "Name",
    "description": "Description",
    "text": "Text",
    "password": "Password",
    "phoneNumber": "Phone number",
    "position": "Position",
    "role": "Role",
    "selectBotId": "Select Bot ID",
    "selectBots": "Select Bots",
    "selectChannelId": "Select Channel ID",
    "selectChannels": "Select Channels",
    "selectSource": "Select Source",
    "selectSourceId": "Select Source ID",
    "selectSubscribers": "Select Subscribers",
    "source": "Source",
    "sourceId": "Source ID",
    "surname": "Surname",
    "selectClient": "Select Client",
  },
  "general": {
    "showColumns": "Show columns",
    "administrator": "Administrator",
    "administrators": "Administrators",
    "approveTo": "Do you want to {{ phrase }}?",
    "createAdministrator": "Create Administrator",
    "editAdministrator": "Edit Administrator",
    "filters": "Filters",
    "home": "Home",
    "pageNotFound": "Page not found",
    "personalData": "Personal Data",
    "table": {
      "dtoTable": "{{ dtoName }} table",
      "noData": "No Data",
      "pagination": "Showing {{currCountOfRows}} to {{toCountOfRows}} of {{total}} entries"
    },
    "viewAdministrator": "View Administrator"
  },
  "links": {
    "botsLink": "Bot's Link",
    "channelsLink": "Channel's Link",
    "contactDeveloper": "Contact Developer",
    "createBotsLink": "Create Bot's Link",
    "createChannelsLink": "Create Channel's Link",
    "link": "Link",
    "links": "Links",
    "support": "Support",
    "table": {
      "deepLink": "Deep",
      "firstName": "First name",
      "resource": "Resource",
      "subscribedAt": "Subscribed At",
      "showHiddenLinks": "Show hidden links",
      "type": "Type",
    },
    "viewLink": "View link"
  },
  "managers": {
    "attemptsLeft": "Attempt: {{attemptsLeft}} / 3",
    "editManager": "Edit manager",
    "enterTgCode": "Check your Telegram and enter code below",
    "manager": "Manager",
    "managers": "Managers",
    "managersTable": "Managers table",
    "signIn": "Sign In",
    "signInQrCode": "Sign In QR Code",
    "signInSendCode": "Sign In Send Code",
    "signInSendCodeAndPassword": "Sign In Send Code & Password",
    "timeExpired": "Time Expired, try again later",
    "timeLeft": "Time left: {{timeLeft}} seconds",
    "viewManager": "View manager"
  },
  "no": "No",
  "profile": {
    "hey": "Hey, {{name}}",
    "logOut": "Log out"
  },
  "services": {
    "actors": "Actors",
    "actor": "Actor",
    "actorsSettings": "Actors Settings",
    "actorsSetting": "Actors Setting",
    "actorsTable": "Actors table",
    "createActor": "Create actor",
    "createGroup": "Create group",
    "createPrompt": "Create prompt",
    "createSetting": "Create setting",
    "deleteGroup": "Delete group",
    "dialogs": "Dialogs",
    "editActor": "Edit actor",
    "editGroup": "Edit group",
    "editPrompt": "Edit prompt",
    "editSetting": "Edit setting",
    "createActorSetting": "Create actor setting",
    "viewActorSetting": "View actor setting",
    "editActorSetting": "Edit actor setting",
    "groups": "Groups",
    "groupsTable": "Groups table",
    "prompts": "Prompts",
    "settings": "Settings",
    "Dialog messages": "Dialog messages",
    "settingsTable": "Settings table",
    "table": {
      "apiHash": "Api Hash",
      "apiId": "Api Id",
      "bio": "Bio",
      "createdAt": "Created at",
      "description": "Description",
      "id": "Id",
      "key": "Key",
      "link": "TG Link",
      "name": "Name",
      "nick": "Nick",
      "note": "Note",
      "phone": "Phone",
      "prompt": "Prompt",
      "session": "Session",
      "sex": "Sex",
      "sheetLink": "Sheet Link",
      "updatedAt": "Updated at",
      "value": "Value"
    },
    "viewActor": "View actor",
    "viewGroup": "View group",
    "viewPrompt": "View prompt",
    "viewSetting": "View setting"
  },
  "subscribers": {
    "createSubscriber": "Create subscriber",
    "editSubscriber": "Edit subscriber",
    "subscribers": "Subscribers",
    "subscribersTable": "Subscribers table",
    "table": {
      "bot": "Bot",
      "buyer": "Buyer",
      "createdAt": "Created at",
      "id": "Id",
      "identifier": "Identifier",
      "isSent": "Sent successfully",
      "message": "Message",
      "messageAt": "Message at",
      "messages": "Messages",
      "name": "Name",
      "received": "Received",
      "resource": "Resource",
      "resources": "Resources",
      "sendAt": "Send at",
      "sent": "Sent",
      "source": "Source",
      "type": "Type",
      "updatedAt": "Updated at",
      "username": "Username"
    },
    "viewSubscriber": "View subscriber"
  },
  "subscriptions": {
    "createSubscription": "Create subscription",
    "editSubscription": "Edit subscription",
    "subscriptions": "Subscriptions",
    "subscriptionsTable": "Subscriptions table",
    "table": {
      "buyer": "Buyer",
      "createdAt": "Created at",
      "id": "Id",
      "identifier": "Identifier",
      "name": "Name",
      "resource": "Resource",
      "source": "Source",
      "updatedAt": "Updated at",
      "url": "Url",
      "username": "Username"
    },
    "viewSubscription": "View subscription"
  },
  "users": {
    "createUser": "Create user",
    "createUserResource": "Create user resource",
    "deleteUser": "Delete user",
    "deleteUserResource": "Delete user resource",
    "editUser": "Edit user",
    "editUserResource": "Edit user resource",
    "table": {
      "createdAt": "Created at",
      "email": "Email",
      "id": "Id",
      "name": "Name",
      "role": "Role",
      "surname": "Username",
      "showDelete": "Show deleted",
      "updatedAt": "Updated at",
    },
    "user": "User",
    "users": "Users",
    "usersResource": "User resource",
    "usersResources": "User resources",
    "usersResourcesTable": "User resources table",
    "usersTable": "Users table",
    "viewUser": "View user",
    "viewUserResource": "View user resource"
  },
  "validation": {
    "email": "Please enter a valid email address",
    "invalidCode": "Please enter a valid code",
    "invalidPassword": "Please enter a valid password",
    "required": "{{field}} is a required field"
  },
  "yes": "Yes",
  "ContactManager": "Contact Manager",
  "Show only messaged": "Show only messaged",
};
